
import promise from 'es6-promise'
import 'babel-polyfill'
import Vue from 'vue'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import App from './App'
import MuseUI from './muse-ui'
import Toast from './muse-ui-plugin/muse-ui-toast'
// import Loading from './muse-ui-plugin/muse-ui-loading'
// import 'muse-ui/dist/muse-ui.css'
import Message from './muse-ui-plugin/muse-ui-message'
import NProgress from './muse-ui-plugin/muse-ui-progress';
import theme from './muse-ui/theme'
// import 'muse-ui-loading/dist/muse-ui-loading.css'
import '../static/css/common.css'
import 'material-design-icons-iconfont'
import ElementUI from 'element-ui';
import MessageBox  from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import moment from 'moment'
import VueRouter from 'vue-router'
import utils from './utils/utils'
import routers from './routers/index'
import echarts from 'echarts'
import lottie from 'vue-lottie';
import Validate from '@/utils/validate'
import ValidateEn from '@/utils/validateEn'
import x2js from 'x2js'
import store from '@/vuex/store'
import XLSX from 'xlsx'
import VueQuillEditor from 'vue-quill-editor'
import axios from 'axios'
import VueI18n from 'vue-i18n'
import animate from 'animate.css'
import * as VueGoogleMaps from 'vue2-google-maps'
import {ConvertFileSize} from "./fs"

import ElementLocale from 'element-ui/lib/locale'
import elENLocate from 'element-ui/lib/locale/lang/en';
import elCNLocate from 'element-ui/lib/locale/lang/zh-CN'
import en from '@/assets/languages/en.json'
import cn from '@/assets/languages/zh.json'

promise.polyfill()

theme.add('zenith-mdm', {
  primary: '#4880FF',
  info: '#602FED',
  success: '#18B47A',
  warning: '#FF9900',
  error: '#FA4645',
  grey: '#929DA5'
}, 'light')
theme.use('zenith-mdm')

Vue.component('lottie', lottie)
Vue.prototype.$znValidate = Validate
Vue.prototype.$enValidate = ValidateEn
Vue.prototype.$axios = axios
Vue.prototype.$store = store
Vue.prototype.$MessageBox = MessageBox
Vue.prototype.$echarts = echarts
Vue.prototype.$x2js = new x2js()
Vue.use(XLSX)


Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(MuseUI)
Vue.use(Toast);
Vue.use(MessageBox);
Vue.use(ElementUI)
Vue.use(VueI18n)
Vue.use(animate)
Vue.use(Message, {
  className: 'custom-confirm-dialog',

});
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDKwgjfcHnVpubDQ48Mb6yrCTlmh32YF34',
    libraries: 'places,drawing', // This is required if you use the Autocomplete plugin
    language: 'en'
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },
})

const router = new VueRouter({
  base: '/mdm/',
  mode: 'history',
  routes: routers
})
router.beforeEach((to, from , next) => {
  NProgress.start();
  if (!hasAuthority(to)) {
    next(
      {
        path: '/forbid'
      }
    )
  }
  next();
});
router.afterEach(() => {
  NProgress.done();
});

function hasAuthority(to) {
  console.log("hasAuthority", to.path);
  const commonPaths = [
    {path: '/'},
    {path: '/private'},
    {path: '/download'},
    {path: '/login'},
    {path: '/findPwd'},
    {path: '/register'},
    {path: '/main'},
    {path: '/profile'},
    {path: '/helpManual'},
    {path: '/mobile'},
    {path: '/saleService'},
    {path: '/forbid'}
  ];
  for (var i = 0; i < commonPaths.length; i++) {
    if (to.path == commonPaths[i].path ||
        to.path.startsWith(commonPaths[i].path)) {
      return true;
    }
  }
  var state = JSON.parse(sessionStorage.getItem("store"));
  for (var i = 0; i < state.menuArray.length; i++) {
    if (state.menuArray[i].menu.uri == to.path) {
      return true;
    }
    if (state.menuArray[i].menuList.length == 0) {
      if (to.path.startsWith(state.menuArray[i].menu.uri)) {
        return true;
      }
    }
    for (var j = 0; j < state.menuArray[i].menuList.length; j++) {
      if (state.menuArray[i].menuList[j].uri == to.path ||
          to.path.startsWith(state.menuArray[i].menuList[j].uri)) {
        return true;
      }
    }
  }
  return false;
}

// 多语言环境
let defaultLocate = 'zh-CN';
if (navigator.language != 'zh' && navigator.language != 'zh-CN') {
  defaultLocate = 'en';
} else {
  defaultLocate = 'zh-CN';
}
// let defaultLocate = 'en';
store.commit("set_lang", defaultLocate);
console.log("main JS:", store.state.lang);

const localMessages = {
  en: {
    ...en,
    ...elENLocate
  },
  zh: {
    ...cn,
    ...elCNLocate
  }
}

const i18n = new VueI18n({ 
  locale: store.state.lang, // 定义默认语言
  // 关闭回退警告
  silentFallbackWarn: true,
  messages: localMessages
  // messages: {   
  //   'zh-CN': require('@/assets/languages/zh.json'),   
  //   'en': require('@/assets/languages/en.json') 
  // }
});
ElementLocale.i18n((key, value) => i18n.t(key, value))

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App},
  template: '<app/>'

})
//  locale.i18n((key, value) => i18n.t(key, value))
// i18n:(key, value) => i18n.t(key, value)
// 全局过滤器
Vue.filter('dateFmt', (input, formatString = 'YYYY-MM-DD') => {
  // es5函数参数设置默认值
  // const lastFormatString = formatString || moment(input) 把时间字符串转成时间对象
  // format(formatString) 把时间对象，按照指定格式，格式化成符合条件的字符串
  return moment(input).format(formatString)
})
Vue.filter('getStrategyType', (code) => {
  if (store.state.lang == "zh-CN" || store.state.lang == "zh") {
    if(code == "policy"){
      return "限制策略";
    }else if(code == "bwlist"){
      return "黑白名单策略";
    }else if(code == "policy_wifi"){
      return "Wifi策略";
    }else if(code == "speed"){
      return "极速配置";
    }
  } else {
    if(code == "policy"){
      return "Limit Strategy";
    }else if(code == "bwlist"){
      return "Black And White List Strategy";
    }else if(code == "policy_wifi"){
      return "Wifi Strategy";
    }else if(code == "speed"){
      return "Fast Config";
    }
  }
})
Vue.filter('getDataDictionary', (code) => {
  var data = store.state.dataDictionary;
  for (var i = 0; i < data.length; i++) {
    if (data[i].code == code) {
      console.log(data[i])
      if (store.state.lang == "zh-CN" || store.state.lang == "zh") {
        return data[i].name;
      }else {
        return data[i].name_en;
      }
    }
  }
  return "";
})
Vue.filter('dataDictionary', (id) => {
  return utils.getDataDictionary(id)
})
Vue.filter('datetime', (code) => {
  if(code != null){
    Date.prototype.toLocaleString = function() {
      // 补0   例如 2018/7/10 14:7:2  补完后为 2018/07/10 14:07:02
      function addZero(num) {
        if(num<10)
          return "0" + num;
        return num;
      }
      // 按自定义拼接格式返回
      return this.getFullYear() + "-" + addZero(this.getMonth() + 1) + "-" + addZero(this.getDate()) + " " +
        addZero(this.getHours()) + ":" + addZero(this.getMinutes()) + ":" + addZero(this.getSeconds());
    };
// 根据毫秒数构建 Date 对象
    var date = new Date(parseInt(code));
// 按重写的自定义格式，格式化日期
    var dateTime = date.toLocaleString();
    return dateTime
  }else {
    return null
  }

})
Vue.filter('formatDateForMS', (time) => {
  var hours, minutes, seconds;
  var totalSeconds = parseInt(time);
  seconds = parseInt(totalSeconds % 60);
  if (seconds < 10) {
    seconds = "0" + seconds;
  }
  minutes = parseInt((totalSeconds % 3600) / 60);
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  hours = parseInt(totalSeconds / 3600);
  if (hours < 10) {
    hours = "0" + hours;
  }
  return hours + ":" + minutes + ":" + seconds;
})
Vue.filter('formatDateFor', (time) => {
  var hours, minutes, seconds, hoursMoji, minutesMoji, secondsMoji;
  if (store.state.lang == "zh-CN" || store.state.lang == "zh") {
    hoursMoji = '小时';
    minutesMoji = '分钟';
    secondsMoji = '秒';
  } else {
    hoursMoji = ' h ';
    minutesMoji = ' m ';
    secondsMoji = ' s';
  }
  var totalSeconds = parseInt(time);
  seconds = parseInt(totalSeconds % 60);
  if (seconds < 10) {
    seconds = "0" + seconds;
  }
  minutes = parseInt((totalSeconds % 3600) / 60);
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  hours = parseInt(totalSeconds / 3600);
  if (hours < 10) {
    hours = "0" + hours;
  }
  if(hours == 0 && minutes == 0){
    return seconds + secondsMoji;
  }
  if(hours == 0 && minutes != 0){
    return minutes + minutesMoji + seconds + secondsMoji;
  }
  return hours + hoursMoji + minutes + minutesMoji + seconds + secondsMoji;
})
Vue.filter('intToArray', (intValue) => {
  var retArray = [];
  for (var i = 1; i <= intValue; i ++) {
    retArray.push(i);
  }
})
Vue.filter('ConvertFileSize', ConvertFileSize)
Vue.filter('formatDateForAMPM', (time) => {
  var y = time.getFullYear();
  var m = time.getMonth() + 1;
  var d = time.getDate();
  var h = time.getHours();
  var mm = time.getMinutes();
  var s = time.getSeconds();
  var str;
  if(h>12) {
      h -= 12;
      str = " PM";
  }else{
      str = " AM";
  }
  h = h < 10 ? "0" + h : h;
  d = d < 10 ? "0" + d : d;
  m = m < 10 ? "0" + m : m;
  mm = mm < 10 ? "0" + mm : mm;
  s = s < 10 ? "0" + s : s;
  var xy = m + "/" + d + "/" + y + " " + h + ":" + mm + ":" + s;
  xy += str;
  return xy;
})
Vue.use(VueQuillEditor)



// WEBPACK FOOTER //
// ./src/main.js